﻿﻿export interface IDonorRecordReview {
    id: number;
    swapNumber: string;
    donorId: number;
    donorAlias: string;
    donorCenter: string;
    recipientId: number;
    recipientAlias: string;
    recipientCenter: string;
    dateRequested: string;
    responseDeadline: string;
    daysLate: number;
    numberOfRequests: number;
    fullyConfident: string;
    safeKey: string;
    centerResponses: number;
    xmSignOff: string;
}
